import React from 'react';
import ReactDOM from 'react-dom/client';
import PortalApp from './PortalApp';
import { initSentry, SentryErrorBoundary } from '../../hub-shared/sentry';
import { initThemeFromStorage } from '@tpct/mission-core/theme/theme';
import { normalizePortalBootstrap } from './utils/normalizePortalBootstrap';

initThemeFromStorage();
initSentry();

const bootstrap = window.AccountingHubPortal;
if (!bootstrap) {
  console.error('AccountingHubPortal bootstrap data not found. Portal cannot initialize.');
} else {
  // Sub-apps call getBootstrapData("AccountingHubPortal") which expects a flat BootstrapData shape.
  // Normalize the portal bootstrap to that shape before mounting the React tree.
  // WHY: UsersApp (and other sub-apps) read `window.AccountingHubPortal` via `getBootstrapData`; policy
  // gates like `capabilities.manageUsers` (and the reports bundle URL) must survive normalization or
  // CTAs silently hide / the reports table silently renders empty. The allowlist lives in one tested
  // place — see normalizePortalBootstrap.
  (window as unknown as Record<string, unknown>).AccountingHubPortal = normalizePortalBootstrap(bootstrap);

  const mountPoint = document.getElementById('accounting-hub-portal-root');

  if (!mountPoint) {
    console.error('Mount point #accounting-hub-portal-root not found. Portal cannot initialize.');
  } else {
    const root = ReactDOM.createRoot(mountPoint);
    root.render(
      <SentryErrorBoundary fallback={<p>Une erreur inattendue est survenue.</p>}>
        <PortalApp bootstrap={bootstrap} />
      </SentryErrorBoundary>
    );
  }
}
